import { Check } from "lucide-react"

import type { ProductPlan } from "@/features/products/types"
import { cn } from "@/lib/utils"
import { formatMoney } from "@/shared/lib/money"

interface PlanCardProps {
  plan: ProductPlan
  selected: boolean
  onSelect: () => void
}

export function PlanCard({ plan, selected, onSelect }: PlanCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "relative flex w-full items-center gap-3 rounded-xl border px-4 py-4 text-left transition-colors",
        selected
          ? "border-main-purple bg-purple-light/10"
          : "border-transparent bg-purple-light/10 hover:bg-purple-light/15",
      )}
    >
      {plan.badge && (
        <span className="absolute -top-2 right-4 rounded-full bg-main-purple px-2 py-0.5 text-[10px] font-semibold uppercase text-white">
          {plan.badge}
        </span>
      )}
      <span
        className={cn(
          "flex size-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors",
          selected ? "border-main-purple bg-main-purple" : "border-purple-light/40",
        )}
      >
        {selected && <Check className="size-3.5 text-white" />}
      </span>
      <span className="flex-1 text-base font-semibold text-purple-light">{plan.name}</span>
      <span className="text-base font-semibold text-purple-light">
        {formatMoney(plan.price, plan.currency)}
      </span>
    </button>
  )
}
